module.exports = __webpack_public_path__ + "img/pharmeleon.888d3132.jpg";